
import {Component, Vue} from "vue-property-decorator";
import OrderPane from "../components/order-pane.vue";
import DatePicker from "@/components/date-picker.vue";
import {apiShopWithdrawLists} from "@/api/order";
import ExportData from "@/components/export-data/index.vue";
import {RequestPaging} from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import lsPagination from "@/components/ls-pagination.vue";

@Component({
  components: {
    lsPagination,
    LsDialog,
    OrderPane,
    DatePicker,
    ExportData,
  },
})
export default class Order extends Vue {
  // S Data

  apiShopWithdrawLists = apiShopWithdrawLists;

  index = 0;

  pager = new RequestPaging();

  form: any = {
    bank_name: "", //卡信息
    shop_name: "", //商户名称
  };

  // E Data

  // S Methods

  // 获取订单信息
  getOrderLists() {
    // let status: any =
    //   this.activeName == "all" ? "" : OrderType[this.activeName];
    this.pager
        .request({
          callback: apiShopWithdrawLists,
          params: {
            // order_status: status,
            ...this.form,
          },
        })
  }

  // 重置搜索
  reset() {
    Object.keys(this.form).map((key) => {
      this.$set(this.form, key, "");
    });
    this.getOrderLists();
  }

  // 获取订单其他 方式数据

  // E Methods

  // S  life cycle

  created() {
    // 获取订单信息
    this.getOrderLists();
  }

  // E life cycle
}
